import { profileType } from "@utils/enum";
import Exit from "@assets/images/icons/exit_to_app.svg";

export const addToZoho = {
  icon: <Exit />,
  name: "Export to Zoho",
};

export const addToHubspot = {
  icon: <Exit />,
  name: "Export to Hubspot",
};

export const portsFilters = {
  tagList: [],
};

export let portsPayload = {
  type: profileType.ports,
  filters: { ...portsFilters },
  company_name: "",
  from: 0,
};

export const pendoEventType = {
  ports: "_ports_",
};
